import styled from 'styled-components';

export const DrawerSeparator = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.disabled};
  width: 100%;
  margin-bottom: 1rem;
`;
